// Function to check if DST is active
const isDST=(country,state_obtained, the_date)=> {
    
	//alert(JSON.stringify(the_date))
	let start_dateAndend_date = new Array();


	let dst_group = get_dst_group(country); // country is something like "United States" or "Australie" etc, and the return dst_group is something like 0, 1, 2 , 3,  99
    if (dst_group === 99 || dst_group === 0) { // '99 means, we do not have the data for this country.

		return false; //we could also return 99 here if we are gonna inform the user, dst info is not applied.
	}

    //here we are dealing with a dst_group, where the start and end date is computable!

    // forst, we have to get the start and end date for this dst_group!

    // get start and end date as a array
    start_dateAndend_date = get_start_and_end_date(dst_group,the_date,state_obtained);

    // now we know the start_date & end_date!

    // check to see if the passed date (the_date) falls into the DST boundaries or not!

    if (is_date_between(the_date, start_dateAndend_date[0], start_dateAndend_date[1],0))
    {
        return true;
    }
    return false;

}

const get_dst_group = (country) =>
{
	//	we got this data from pur prayertimes database
	//	see dst-group.htm


	let dst_0_group = new Array("afghanistan","algeria","angola","anguilla","antarctica","antigua and barbuda","argentina","aruba","ashmore and cartier islands","bahrain","bangladesh","barbados","bassas da india","belize","benin","bhutan","bodies of water","bolivia","botswana","bouvet island","british indian ocean territory","british virgin islands","brunei","burkina faso","burundi","cambodia","cameroon","cape verde","cayman islands","central african republic","chad","china","christmas island","clipperton island","cocos (keeling) islands","colombia","comoros","congo (brazzaville)","congo (kinshasa)","cook islands","coral sea islands","costa rica","cote d'ivoire","djibouti","dominica","dominican republic","east timor","ecuador","el salvador","equatorial guinea","eritrea","ethiopia","europa island","fiji","french guiana","french polynesia","french southern and antarctic lands","gabon","gambia","ghana","glorioso islands","grenada","guadeloupe","guatemala","guinea","guinea-bissau","guyana","haiti","heard island and mcdonald islands","holy see (vatican city)","honduras","hong kong","iceland","india","indonesia","jamaica","jan mayen","japan","juan de nova island","kenya","kiribati","kuwait","laos","lesotho","liberia","libya","macau","madagascar","malawi","malaysia","maldives","mali","martinique","mauritania","mauritius","mayotte","montserrat","mozambique","myanmar (burma)","nauru","nepal","netherlands antilles","new caledonia","nicaragua","niger","nigeria","niue","norfolk island","north korea","oman","pakistan","panama","papua new guinea","paracel islands","peru","philippines","pitcairn islands","qatar","reunion","rwanda","saint helena","saint kitts and nevis","saint lucia","saint vincent and grenadines","samoa","sao tome and principe","saudi arabia","senegal","seychelles","sierra leone","singapore","solomon islands","somalia","south africa","south georgia and south sandwich islands","south korea","spratly islands","sri lanka","sudan","suriname","swaziland","taiwan","tajikistan","tanzania","thailand","togo","tokelau","trinidad and tobago","tromelin island","tunisia","turkmenistan","tuvalu","uganda","undersea features","united arab emirates","uruguay","uzbekistan","vanuatu","venezuela","vietnam","wallis and futuna","western sahara","yemen","zambia","zimbabwe","russia");
	let dst_1_group = new Array("albania","andorra","armenia","austria","azerbaijan","belarus","belgium","bosnia and herzegovina","bulgaria","croatia","cyprus","czech republic","denmark","estonia","faroe islands","finland","france","georgia","germany","gibraltar","greece","greenland","guernsey","hungary","ireland","isle of man","italy","jersey","kazakhstan","kyrgyzstan","latvia","lebanon","liechtenstein","lithuania","luxembourg","macedonia","malta","moldova","monaco","morocco","netherlands","norway","poland","portugal","romania","san marino","serbia and montenegro","slovakia","slovenia","spain","svalbard","sweden","switzerland","turkey","ukraine","united kingdom","lebanon");
	let dst_2_group = new Array("bahamas","bermuda","canada","saint pierre and miquelon","turks and caicos islands","united states");
	let dst_3_group = new Array("israel");
	let dst_4_group = new Array("iran");
	let dst_5_group = new Array("jordan");
	let dst_6_group = new Array("syria");
	let dst_7_group = new Array("iraq");
	let dst_8_group = new Array("palestine","west bank", "gaza strip");
	let dst_9_group = new Array("egypt");
	let dst_10_group = new Array("namibia");
	let dst_11_group = new Array("new zealand","chatham");
	let dst_12_group = new Array("brazil");
	let dst_13_group = new Array("chile");
	let dst_14_group = new Array("cuba");
	let dst_15_group = new Array("australia");
	let dst_16_group = new Array("mexico");
	let dst_17_group = new Array("paraguay");
	let dst_18_group = new Array("tonga");
	let dst_19_group = new Array("mongolia");


	if(stringIsInArray(dst_0_group, country))
    {
		return 0;

    }
	else if(stringIsInArray(dst_1_group, country))
    {
		return 1;
    }
	else if(stringIsInArray(dst_2_group, country))
    {

		return 2;
    }
	else if(stringIsInArray(dst_3_group, country))
    {

		return 3;
    }
	else if(stringIsInArray(dst_4_group, country))
    {

		return 4;
    }
	else if(stringIsInArray(dst_5_group, country))
    {

		return 5;
    }
	else if(stringIsInArray(dst_6_group, country))
    {

		return 6;
    }
	else if(stringIsInArray(dst_7_group, country))
    {

		return 7;
    }
	else if(stringIsInArray(dst_8_group, country))
    {

		return 8;
    }
	else if(stringIsInArray(dst_9_group, country))
    {

		return 9;
    }
	else if(stringIsInArray(dst_10_group, country))
    {

		return 10;
    }
	else if(stringIsInArray(dst_11_group, country))
    {

		return 11;
    }
	else if(stringIsInArray(dst_12_group, country))
    {

		return 12;
    }
	else if(stringIsInArray(dst_13_group, country))
    {

		return 13;
    }
	else if(stringIsInArray(dst_14_group, country))
    {

		return 14;
    }
	else if(stringIsInArray(dst_15_group, country))
    {

		return 15;
    }
	else if(stringIsInArray(dst_16_group, country))
    {

		return 16;
    }
	else if(stringIsInArray(dst_17_group, country))
    {

		return 17;
    }
	else if(stringIsInArray(dst_18_group, country))
    {

		return 18;
    }
	else if(stringIsInArray(dst_19_group, country))
    {

		return 19;
    }
    else
    {
		return 99;

    }
}

const  stringIsInArray = (array_data, string_val) =>
{
	let isfound = false;
	let lower_case_string = string_val.toLowerCase();

	for (var i = 0; i < array_data.length; i++ ) {
	    if(lower_case_string == array_data[i])
	    {
	    	isfound = true;
	    	break;
	    }
	}
	return isfound;
}


const get_start_and_end_date = (dst_group, the_date, state) =>
{
	
	let dates = new Array();
	let comp1,comp2,comp3;
	let actual_year, actual_day, actual_month;
	let rules, start_dst_month, start_dst_day, start_dst_year;
	let end_dst_month, end_dst_day, end_dst_year;
	let state_obtained = state ? state.toLowerCase() : "";
	//new code
	actual_year = the_date ?  parseInt(the_date.getFullYear()) : "";
	actual_day 	= the_date ?  parseInt(the_date.getDate()) : "";
	actual_month= the_date ? parseInt(the_date.getMonth()) + 1 : "";

	switch (dst_group) {
		
		case 0: //'NO DST Country
			rules= "NO DST Country, put dummy date on year 1900";
			start_dst_month = 1;
			start_dst_day = 1;
			start_dst_year = 1900;
			end_dst_month = 2;
			end_dst_day = 1;
			end_dst_year = 1900;
			break;
		case 1: //'EU dst group - START: last sunday in march, END: last sunday in oct
			rules= "EU dst group - START: last sunday in march, END: last sunday in oct"
			start_dst_year=actual_year;
			start_dst_month=3;
			comp1=parseInt( 4+ start_dst_year*5/4);
			start_dst_day = 31-(comp1 %  7);
			end_dst_year=actual_year;
			end_dst_month=10;
			comp2=parseInt( 1+ start_dst_year*5/4); // 'oct
			end_dst_day= 31-(comp2 %  7);
			
			break;
		case 2: // 'North America dst group - START: second sunday in march, END: first sunday in nov

			if ( ( state_obtained === "arizona" ) ||
				 ( state_obtained === "hawaii" ) ) {
				rules="Exception: State of Arizona & Hawaii,USA does not observe DST";
				start_dst_year=1900;
				start_dst_month=3;
				start_dst_day=1;
				end_dst_year=1900;
				end_dst_month=11;
				end_dst_day=1;
			} else {
				rules="North America dst group - START: second sunday in march, END: first sunday in nov";
				start_dst_year=actual_year;
				start_dst_month=3;
				comp1=parseInt(1+actual_year*5/4);
				start_dst_day= 14-(comp1 %  7);
				end_dst_day= 7-(comp1 %  7);
				end_dst_year=actual_year;
				end_dst_month=11;
				
			}
			break;
		case 3: // 'Israel dst group 3 -  START: Friday before the last Sunday of March, END: last Sunday of October
			rules="Israel dst group 3 -  START: Friday before the last Sunday of March, END: last Sunday of Oct";
			start_dst_year=actual_year;
			start_dst_month=3;
			comp1=parseInt( 4+ start_dst_year*5/4);
			start_dst_day = 31-(comp1 %  7)- 2;
			end_dst_year=actual_year;
			end_dst_month=10;
			comp2=parseInt( 1+ end_dst_year*5/4); // 'oct
			end_dst_day= 31-(comp2 %  7);
			break;
		case 4: // 'Iran dst group - START: March 22, END: Sept 22

			rules="Iran dst group - START: March 22, END: Sept 22";
			start_dst_year=actual_year;
			start_dst_month=3;
			start_dst_day= 22;
			end_dst_year=actual_year;
			end_dst_month=9;
			end_dst_day= 22;
			break;
		case 5: //'JORDAN dst group - START: LAST Thursday in March, END:last Friday in SEPT

			rules="JORDAN dst group - START: LAST Thursday in March, END:last Friday in SEPT";
			start_dst_year=actual_year;
			start_dst_month=3;
			comp1=parseInt( 0+ start_dst_year*5/4); //'march
			start_dst_day = 31-(comp1 %  7);
			end_dst_year= actual_year;
			end_dst_month=9;
			comp2=parseInt( 0+ end_dst_year*5/4); // 'sept
			end_dst_day= 30-(comp2 %  7);
			break;
		case 6: // 'Syria dst group 6 -  START: LAST Friday in March, END:last Friday in OCT;
			rules="START: LAST Friday in March, END:last Friday in OCT";
			start_dst_year=actual_year;
			start_dst_month=3;
			comp1=parseInt( 6+start_dst_year*5/4); // 'march
			start_dst_day = 31-(comp1 %  7);
			end_dst_year=actual_year;
			end_dst_month=10;
			comp2=parseInt( 3+end_dst_year*5/4); // 'oct
			end_dst_day= 31-(comp2 %  7);
			break;
		case 7: // 'IRAQ dst group - START: first Friday in April, END:last Friday in oct
			rules="IRAQ dst group - START: first Friday in April, END:last Friday in oct";
			start_dst_year=actual_year;
			start_dst_month=4;
			comp1=parseInt( 6+ actual_year*5/4); // 'april
			start_dst_day = 7-(comp1 %  7);
			end_dst_year= actual_year;
			end_dst_month=10;
			comp2=parseInt( 3+ actual_year*5/4); // 'oct
			end_dst_day= 31-(comp2 %  7);
			break;
		case 8: // 'Palestine dst group 8 -  START: last Friday of March, END: 4th Friday of October
			rules="Palestine dst group 8 -  START: last Friday of March, END: Saturday before last Sunday in October at 02:00 wikipedia";
			start_dst_year=actual_year;
			start_dst_month=3;
			comp1=parseInt( 6+ start_dst_year*5/4); // 'march
			start_dst_day = 31-(comp1 %  7);
			end_dst_year=actual_year;
			end_dst_month=10;
			comp2=parseInt( 0+ end_dst_year*5/4); // 'oct
			end_dst_day= 28-(comp2 %  7);
			break;
		case 9: // 'EGYPT dst group - START: LAST Friday in April, END:last THURSDAY in SEPT
			rules 			= "EGYPT dst group - START: LAST Friday in April, END:last THURSDAY in SEPT";
			start_dst_year 	= actual_year;
			start_dst_month = 4;
			comp1 			= parseInt( 1+ start_dst_year*5/4); // 'april
			start_dst_day 	= 30-(comp1 %  7);
			end_dst_year 	= actual_year;
			end_dst_month 	= 9;
			comp2 			=parseInt( 1+ end_dst_year*5/4); // 'sept
			end_dst_day 	= 30-(comp2 %  7);
			break;
		case 10: // ' Namibia START:first sunday in sept END:first SUNDAY IN April folowing year
			rules = "Namibia START:first sunday in sept END:first SUNDAY IN April folowing year";
			if ( actual_month > 4 ) {
				start_dst_year=actual_year;
				end_dst_year=actual_year+1;
			} else {
				start_dst_year=actual_year-1;
				end_dst_year=actual_year;
			}
			start_dst_month=9;
			comp1=parseInt( 3+ start_dst_year*5/4); // 'september
			start_dst_day = 7-(comp1 %  7);
			end_dst_month=4;
			comp2=parseInt( 4+ end_dst_year*5/4); // 'april
			end_dst_day= 7-(comp2 %  7);
			break;
		case 11: // ' New Zealand & Catham START:last sunday in sept END:first SUNDAY IN April folowing year
			rules="New Zealand & Catham START:last sunday in sept END:first SUNDAY IN April folowing year";
			if ( actual_month > 4 ) {
				start_dst_year=actual_year;
				end_dst_year=actual_year+1;
			} else {
				start_dst_year=actual_year-1;
				end_dst_year=actual_year;
			}
			start_dst_month=9;
			comp1=parseInt( 5+ start_dst_year*5/4); // 'september
			start_dst_day = 30-(comp1 %  7);
			end_dst_month=4;
			comp2=parseInt( 4+ end_dst_year*5/4); // 'april
			end_dst_day= 7-(comp2 %  7);
			break;
		case 12: // ' NON EQUATOR (southern) States of Brazil use DST, EQUATOR state doesnt. START:third sunday in oct END:third SUNDAY IN FEB folowing year
			if (( state_obtained === "rio grande do sul" ) ||
				( state_obtained === "santa catarina" ) ||
				( state_obtained === "parana" ) ||
				( state_obtained === "sao paulo" ) ||
				( state_obtained === "rio de janeiro" ) ||
				( state_obtained === "espirito santo" ) ||
				( state_obtained === "minas gerais" ) ||
				( state_obtained === "goias" ) ||
				( state_obtained === "mato grosso" ) ||
				( state_obtained === "mato grosso do sul" ) ||
				( state_obtained === "distrito federal" )){
				rules= "NON EQUATOR (southern) States of Braziluse DST START:third sunday in oct END:third SUNDAY IN FEB folowing year";
				if ( actual_month > 2 ) {
					start_dst_year=actual_year;
					end_dst_year=actual_year+1;
				} else {
					start_dst_year=actual_year-1;
					end_dst_year=actual_year;
				}
				start_dst_month=10;
				end_dst_month=2;
				comp1=parseInt( 5+ start_dst_year*5/4); // 'october
				start_dst_day = 21-(comp1 %  7);
				comp2=parseInt( 1+ end_dst_year*5/4); // 'april
				if ( (end_dst_year %  4) === 0 ) {
					comp3 = 1;
				} else {
					comp3 = 0;
				}
				end_dst_day= 21-(comp2 %  7) + comp3;
			} else {
				rules="Exception: Equator State (nothern)of Brazil does not observe DST";
				start_dst_year=1900;
				start_dst_month=3;
				start_dst_day=1;
				end_dst_year=1900;
				end_dst_month=11;
				end_dst_day=1;
			}
			break;
		case 13: // 'Chile dst group 14 - START on 2015, always use DST
			rules= "Chile dst group 14 - Since 2015, always use DST, not use standard";
			start_dst_day= 11;
			start_dst_month=10;
			start_dst_year=2014;
			end_dst_day= 29;
			end_dst_month=3;
			end_dst_year=2099;
			break;
		case 14: // 'Cuba dst group - START: third sunday in march, END: last sunday in oct
			rules= "Cuba dst group - START: third sunday in march, END: last sunday in oct";
			start_dst_year=actual_year;
			start_dst_month=3;
			comp1=parseInt( 1+actual_year*5/4);
			start_dst_day= 21-(comp1 %  7);
			end_dst_year=actual_year;
			end_dst_month=10;
			comp2=parseInt( 1+actual_year*5/4); // 'oct
			end_dst_day= 31-(comp2 %  7);
			break;
		case 15: // ' Australia START:first sunday in oct END:FIRST SUNDAY IN APRIL folowing year

			if ( ( state_obtained == "queensland" ) ||
				 ( state_obtained == "northern territory" ) ||
				 ( state_obtained == "western australia" ) ){
				rules="Exeption: State of Queensland, Northern Territory and Western Australia do not observe DST";
				start_dst_year=1900;
				start_dst_month=3;
				start_dst_day=1;
				end_dst_year=1900;
				end_dst_month=11;
				end_dst_day=1;

			} else {
		
				rules = "Australia START:first sunday in oct END:FIRST SUNDAY IN APRIL folowing year";
				//if ( actual_month > 3 ){ //changed By  Nazrul 02/27/2025
				if ( actual_month > 4 ){
					start_dst_year=actual_year;
					end_dst_year=actual_year+1;
				} else {
					start_dst_year=actual_year-1;
					end_dst_year=actual_year;
				}
				start_dst_month=10;
				end_dst_month=4;
				comp1=parseInt( 5+ start_dst_year*5/4); // 'october
				start_dst_day = 7-(comp1 %  7);
				comp2=parseInt( 4+ end_dst_year*5/4); // 'april
				end_dst_day= 7-(comp2 %  7);
				
			}
			break;
		case 16: // 'Mexico dst group - first sunday in april, last sunday in oct
			if ( state_obtained == "sonora" ) {
				rules="Exeption: State of Sonora, Mexico does not observe DST";
				start_dst_year=1900;
				start_dst_month=3;
				start_dst_day=1;
				end_dst_year=1900;
				end_dst_month=11;
				end_dst_day=1;
			} else {
				rules= "Mexico dst group - first sunday in april, last sunday in oct";
				start_dst_year=actual_year;
				start_dst_month=4;
				comp1=parseInt( 4+actual_year*5/4); // 'april
				start_dst_day = 7-(comp1 %  7);

				end_dst_year=actual_year;
				end_dst_month=10;
				comp2=parseInt( 1+actual_year*5/4); // 'oct
				end_dst_day= 31-(comp2 %  7);
			}
			break;
		case 17: // ' Paraguay START:third sunday in oct END:second SUNDAY IN MARCH folowing year
			rules= "Paraguay START:third sunday in oct END:second SUNDAY IN MARCH folowing year";
			//if ( actual_month > 3 ) { changed by Nazrul -2/27/2025
			
			if ( actual_month > 4 ) { 
				start_dst_year=actual_year;
				end_dst_year=actual_year+1;
			} else {
				start_dst_year=actual_year-1;
				end_dst_year=actual_year;
			}
			start_dst_month=10;
			end_dst_month=3;
			comp1=parseInt( 5+ start_dst_year*5/4);  //'october
			start_dst_day = 21-(comp1 %  7);
			comp2=parseInt( 1+end_dst_year*5/4);
			end_dst_day= 14-(comp2 %  7);
			break;

		case 18: // ' Tonga START:first sunday in Nov END:last Sunday in Jan folowing year
			rules= "Tonga START:first sunday in Nov END:last Sunday in Jan folowing year";
			if ( actual_month > 1 ) {
				start_dst_year=actual_year;
				end_dst_year=actual_year+1;
			} else {
				start_dst_year=actual_year-1;
				end_dst_year=actual_year;
			}
			start_dst_month=11;
			comp1=parseInt( 1+ start_dst_year*5/4);
			start_dst_day= 7-(comp1 %  7);
			end_dst_month=1;
			comp2=parseInt( 1+ end_dst_year*5/4); // 'oct
			if ((end_dst_year %  4)== 0 ) {
				comp3=1;
			} else {
				comp3=0;
			}
			end_dst_day= 31-(comp2 %  7) + comp3;
			break;

		case 19: // 'Mongolia dst group - START: last sunday in march, END: last sunday in SEPT
			rules= "Mongolia dst group - START: last sunday in march, END: last sunday in SEPT";
			start_dst_year=actual_year;
			start_dst_month=3;
			comp1=parseInt( 4+ start_dst_year*5/4); // 'march
			start_dst_day = 31-(comp1 %  7);
			end_dst_year=actual_year;
			end_dst_month=9;
			comp2=parseInt( 5+ start_dst_year*5/4); // 'oct
			end_dst_day= 30-(comp2 %  7);
			break;
		default:
			//no match,
	}
	
	console.log ('dst_group: ' + dst_group + 'rules:' + rules);

	//Nazrul: custom logic on 02/27/2025
	//alert(dst_group);
	if(dst_group === 14 || dst_group === 16 || dst_group === 17)
	{
		end_dst_day = end_dst_day - 1;
	}

	
	let localdate = new Date();
	//if(localdate.toString().toLocaleLowerCase().includes("pacific standard time"))
	if(localdate.toString().toLocaleLowerCase().includes("-"))
	{

		start_dst_day = start_dst_day - 1;	
		end_dst_day = end_dst_day - 1;		
	}
	//new code
    dates[0] = new Date(start_dst_year, start_dst_month-1, start_dst_day); 
	dates[1] = new Date(end_dst_year, end_dst_month-1, end_dst_day);
    console.log ('start/end dates: ' + start_dst_year, start_dst_month-1, start_dst_month + ' / ' + end_dst_year, end_dst_month-1, end_dst_day );
	return dates;
}

const is_date_between = (check,from,to,boundaries_included) => {
    let from_date,to_date,cDate;
    from_date = Date.parse(from);
    to_date = Date.parse(to);
    let check_date = Date.parse(check);

	if ( boundaries_included )
	{
		if((check_date <= to_date && check_date >= from_date)) {
			return true;
		}
		return false;
	}
    else
    {
		if((check_date < to_date && check_date >= from_date)) {
			//console.log ( 'returning TRUE for checking date ' + check + ' to see between these 2 dates-> ' + from + ' ----- ' + to );
			return true;
		}
		//console.log ( 'returning FALSE for checking date ' + check + ' to see between these 2 dates-> ' + from + ' ----- ' + to );
		return false;
	}
}

const getCountryName = async(lat,lon) =>
  {
      const apiKey = window.settings.googleMapAPIKey; // Replace with your API key
          const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&key=${apiKey}`;
            let country = "Unknown";
              let state = "Unknown";
          try {
              const response = await fetch(url);
              const data = await response.json();


              if (data.status === "OK") {
                  for (const result of data.results) {
                      for (const component of result.address_components) {
                           if (component.types.includes("country")) {
                              country = component.long_name; // Country name
                           }
                           if (component.types.includes("administrative_area_level_1")) {
                                state = component.long_name;
                           }

                      }
                  }
              }
			                if(country !== "Unknown")
                           {
                                return {country:country, state:state}
                           }
               console.error("Country not found");
                return {country:country, state:state};
          } catch (error) {
              console.error("Error fetching location data:", error);
                return {country:country, state:state};
          }
             return {country:country, state:state};
  }

export{

    getCountryName,
    isDST,
    get_dst_group,
    stringIsInArray,
	is_date_between,
	get_start_and_end_date
}
